<template>
  <section class="min-h-0 flex-1 overflow-hidden bg-slate-50 dark:bg-slate-950">
    <div v-if="loading" class="border-b border-slate-200 bg-white px-4 py-2 text-sm text-slate-500 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-400">
      Loading tasks...
    </div>

    <!-- Board view is temporary. Do not grow it here; it will move to a different framework as a second screen. -->
    <div class="flex h-full min-h-0 gap-3 overflow-x-auto p-4">
      <StatusColumn
        v-for="status in statuses"
        :key="status"
        :data-status="status"
        :store="store"
        :status="status"
        :label="statusLabel(status)"
        :tasks="tasksByStatus[status] || []"
        @dragstart="startDrag"
        @reorder="reorderTask"
      />
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import StatusColumn from './StatusColumn.vue'

const props = defineProps({
  store: {
    type: Object,
    required: true,
  },
})

const draggingTaskId = ref(null)
const statuses = computed(() => props.store.displayStatuses)
const tasksByStatus = computed(() => props.store.groupedByStatus.value)
const loading = computed(() => props.store.loading.value)

function startDrag(task) {
  draggingTaskId.value = task.id
}

async function reorderTask({ status, position }) {
  if (!draggingTaskId.value || props.store.projectFilterId.value) {
    draggingTaskId.value = null
    return
  }

  const taskId = draggingTaskId.value
  draggingTaskId.value = null

  try {
    await props.store.reorderTask({
      taskId,
      status,
      position,
    })
  } catch (_) {
    // The shared store exposes the visible error banner.
  }
}

function statusLabel(status) {
  return status.replaceAll('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase())
}
</script>
